import React from 'react';
import progressbar from "../media/progressbar.gif";

class IndefiniteProgressbar extends React.Component {
	render(){
		return <img src={progressbar} alt={this.props.alt||"Caricamento in corso…"}/>;
	}
}

export default IndefiniteProgressbar;